import { useMutation } from '@tanstack/react-query';
import { useAccountApi } from '../../hooks/use-settings-api';
import type { UpdateAccountApiRequest } from '../../types';

export function useUpdateAccount() {
  const { accountApi } = useAccountApi();

  return useMutation({
    mutationFn: (payload: UpdateAccountApiRequest) => accountApi.updateAccount(payload),
  });
}
